import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './app-sidebar.component.html'
})
export class AppSidebarComponent {
  @Input() public navigation: any = [];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/components/app-sidebar/app-sidebar.component.ts